export enum TaskPriorityEnum {
    HIGH = 'ALTA',
    MEDIUM = 'MEDIA',
    LOW = 'BAIXA',
    NONE = 'NENHUMA'
}

export enum TaskPriorityIdEnum {
    'ALTA' = 1,
    'MEDIA' = 2,
    'BAIXA' = 3,
    'NENHUMA' = 4
}

/**
 * Obtém a descrição da prioridade com base no ID
 * @param id ID da prioridade
 * @returns Descrição da prioridade
 */
export function getTaskPriorityDescriptionById(id: number): string {
    const entries = Object.entries(TaskPriorityIdEnum);
    const entry = entries.find(([_, enumValue]) => enumValue === id);
    return entry ? entry[0] : 'NENHUMA';
}

/**
 * Obtém o ID da prioridade com base na descrição
 * @param description Descrição da prioridade
 * @returns ID da prioridade
 */
export function getTaskPriorityIdByDescription(description: string): number {
    return TaskPriorityIdEnum[description as keyof typeof TaskPriorityIdEnum] || 4; // Default to NONE (4) if not found
} 